import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGradingsad = ({ title, titleId,...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "36px",
	height: "36px",
	viewBox: "0 0 36 36",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title === undefined ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: "happiness copy"
	}) : title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "Material-Design-Stickersheet",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Genus:NGPI",
			transform: "translate(-1265.000000, -319.000000)",
			fill: "#C01616",
			fillRule: "nonzero",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "Group-4",
				transform: "translate(1265.000000, 319.000000)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "M18,0 C8.07481182,0 0,8.07481182 0,18 C0,27.9251882 8.07481182,36 18,36 C27.9251882,36 36,27.9251882 36,18 C36,8.07481182 27.9253098,0 18,0 Z M18,34.0540278 C13.5904269,34.0540278 9.59060258,32.2666523 6.68636063,29.3788294 C5.52656117,28.2255976 4.54202084,26.8964986 3.7754294,25.4358032 C2.60784605,23.2114353 1.94597224,20.6816714 1.94597224,18 C1.94597224,9.14777227 9.14777227,1.94597224 18,1.94597224 C22.1988,1.94597224 26.0255544,3.56696712 28.8892958,6.2151921 C30.3740726,7.58807551 31.6001568,9.2368005 32.4842363,11.0796362 C33.4900607,13.1762997 34.0540278,15.5235071 34.0540278,18 C34.0540278,26.8522277 26.8522277,34.0540278 18,34.0540278 Z",
						id: "Shape"
					}),
					/* @__PURE__ */ _jsx("circle", {
						id: "Oval",
						cx: 12,
						cy: 14,
						r: 2
					}),
					/* @__PURE__ */ _jsx("circle", {
						id: "Oval",
						cx: 24,
						cy: 14,
						r: 2
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M17.4652294,28 C21.2683747,28 24.9131478,26.1302045 27,23.0257299 L25.348825,22 C23.4325086,24.8507589 19.9273095,26.4416796 16.4174416,26.0523653 C13.6822338,25.7491584 11.1528239,24.2341871 9.65105211,22 L8,23.0257299 C9.81716481,25.7293147 12.8796834,27.5624938 16.1921082,27.9298384 C16.617342,27.9769671 17.0419614,28 17.4652294,28 Z",
						id: "Path",
						transform: "translate(17.500000, 25.000000) scale(1, -1) translate(-17.500000, -25.000000) "
					})
				]
			})
		})
	})]
});
const ForwardRef = forwardRef(SvgGradingsad);
export { ForwardRef as ReactComponent };
